import { createJSONEditor } from 'vanilla-jsoneditor'
import { useEffect, useRef } from 'react'
import './JsonEditor.scss'
import { isEmpty } from 'lodash'
import { JSON_EDITOR_INDENTATION } from 'constants/general-constants'
import { utilityService } from 'services/UtilityService'

const JsonEditor = props => {
  const {
    headerOptionsToRemove = [],
    onChange,
    onRenderContextMenu,
    readOnly = false,
    handleChangeWithErrors = false,
    mode
  } = props
  const refContainer = useRef(null)
  const refEditor = useRef(null)

  useEffect(() => {
    // create editor
    refEditor.current = createJSONEditor({
      mode,
      target: refContainer.current,
      props: {
        indentation: JSON_EDITOR_INDENTATION,
        readOnly,
        onRenderMenu: (items, context) => {
          if (isEmpty(headerOptionsToRemove)) return items
          let neededItems = items
          const isTreeView = context.mode === 'tree'
          const isTextView = context.mode === 'text'
          // remove table
          // let neededItems = items.filter(item => {
          //   if (item.text === 'table') {
          //     return false
          //   }
          //   return true
          // })
          if (isTreeView) {
            const treeItems = neededItems.filter((item, index) => {
              const title = utilityService.toLowerCaseAndReplaceSpaces(item?.title) || ''
              const isLastSeparator = index > 6 && item.type === 'separator'
              if (headerOptionsToRemove.includes(title) || isLastSeparator) {
                return false
              }
              return true
            })
            neededItems = treeItems
          } else if (isTextView) {
            const textItems = neededItems.filter((item, index) => {
              const title = utilityService.toLowerCaseAndReplaceSpaces(item?.title) || ''
              const isLastSeparator = index > 6 && item.type === 'separator'
              if (headerOptionsToRemove.includes(title) || isLastSeparator) {
                return false
              }
              return true
            })
            neededItems = textItems
          }
          return neededItems
        },
        onRenderContextMenu: (items, context) => {
          if (onRenderContextMenu) {
            const customMenu = onRenderContextMenu(items, context)
            return customMenu
          }
          return items
        },
        onChange: (updatedContent, previousContent, { contentErrors, patchResult }) => {
          // handle change function will only pass value if there are no errors by default
          if (isEmpty(contentErrors) || handleChangeWithErrors) {
            onChange(updatedContent)
          }
        }
      }
    })

    return () => {
      // destroy editor
      if (refEditor.current) {
        refEditor.current.destroy()
        refEditor.current = null
      }
    }
  }, [])

  // update props
  useEffect(() => {
    if (refEditor.current) {
      const { mode, onChangeMode = null, content, readOnly, onChange, handleChangeWithErrors, onRenderContextMenu, headerOptionsToRemove } = props
      const propsDetails = {
        mode,
        content,
        readOnly,
        onRenderMenu: (items, context) => {
          if (isEmpty(headerOptionsToRemove)) return items
          let neededItems = items
          const isTreeView = context.mode === 'tree'
          const isTextView = context.mode === 'text'
          // remove table
          // let neededItems = items.filter(item => {
          //   if (item.text === 'table') {
          //     return false
          //   }
          //   return true
          // })
          if (isTreeView) {
            const treeItems = neededItems.filter((item, index) => {
              const title = utilityService.toLowerCaseAndReplaceSpaces(item?.title) || ''
              const isLastSeparator = index > 6 && item.type === 'separator'
              if (headerOptionsToRemove.includes(title) || isLastSeparator) {
                return false
              }
              return true
            })
            neededItems = treeItems
          } else if (isTextView) {
            const textItems = neededItems.filter((item, index) => {
              const title = utilityService.toLowerCaseAndReplaceSpaces(item?.title) || ''
              const isLastSeparator = index > 6 && item.type === 'separator'
              if (headerOptionsToRemove.includes(title) || isLastSeparator) {
                return false
              }
              return true
            })
            neededItems = textItems
          }
          return neededItems
        },
        onRenderContextMenu: (items, context) => {
          if (onRenderContextMenu) {
            const customMenu = onRenderContextMenu(items, context)
            return customMenu
          }
          return items
        },
        onChange: (updatedContent, previousContent, { contentErrors, patchResult }) => {
          // handle change function will only pass value if there are no errors by default
          if (isEmpty(contentErrors) || handleChangeWithErrors) {
            onChange(updatedContent)
          }
        }
      }
      if (onChangeMode) {
        propsDetails.onChangeMode = onChangeMode
      }
      refEditor.current.updateProps(propsDetails)
    }
  }, [props])

  return (
    <>
      <div className='svelte-jsoneditor-react' ref={refContainer} />
    </>
  )
}

export default JsonEditor
